import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import localeSe from '@angular/common/locales/se';
import localeEn from '@angular/common/locales/en';
import localeHe from '@angular/common/locales/he';
import { registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminGuard, AuthGuard, LoginWrapperComponent } from 'gung-standard';
import { CarLinerProductDetailsComponent } from './components/car-liner-product-details/car-liner-product-details.component';
import { CarLinerPimProductComponent } from './components/pim/car-liner-pim-product/car-liner-pim-product.component';
import { CarLinerOrderDetailsComponent } from './components/car-liner-order-details/car-liner-order-details.component';
import { CarLinerUserDetailsComponent } from './components/car-liner-user-details/car-liner-user-details.component';
import { CarLinerCustomerDetailsComponent } from './components/car-liner-customer-details/car-liner-customer-details.component';
import { CarLinerBrochuresHelperService } from './services/car-liner-brochures-helper.service';

@Component({
    selector: 'car-liner-root',
    template: '<car-liner-app-wrapper></car-liner-app-wrapper>',
    standalone: false
})
export class AppComponent {
  constructor(
    private router: Router,
    translate: TranslateService,
    protected carLinerBrochuresHelperService: CarLinerBrochuresHelperService
  ) {
    translate.use('en');
    registerLocaleData(localeSe);
    registerLocaleData(localeEn);
    registerLocaleData(localeHe);
    this.setupRoutes();

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      localStorage.setItem('selectedLanguage', event.lang);
    });

    this.carLinerBrochuresHelperService.initCheckCartBrouchures();
  }

  private setupRoutes() {
    const routerConfig = this.router.config;
    this.router.resetConfig([
      {
        path: 'forgot-password',
        component: LoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'product/:productId',
        component: CarLinerProductDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'pim/:productId',
        component: CarLinerPimProductComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders/:orderId',
        component: CarLinerOrderDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'login',
        component: LoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'admin/users-details/:username',
        component: CarLinerUserDetailsComponent,
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'customers/:customerId',
        component: CarLinerCustomerDetailsComponent,
        canActivate: [AuthGuard]
      },
      ...routerConfig
    ]);
  }
}
